import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34bed0ba&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=34bed0ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__lodash_24cgfdmwo65apd3bkbnxqthoqi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bed0ba",
  null
  
)

export default component.exports